import React from "react";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
export function StopGuessing() {
  return <section className="bg-paper px-4 py-16 sm:px-6 sm:py-24" data-id="element-283" data-mp="1w11dnmdo2aap">
      <div className="mx-auto max-w-3xl" data-id="element-284" data-mp="2a1c62tumjwxz">
        <SectionHeading eyebrow="Stop guessing your way through complex assessments" title="A More Structured Approach to Every Patient" data-id="element-285" data-mp="29yzpak0lrsmi" />

        <div className="mt-10 space-y-5 text-lg leading-relaxed text-ink/85 sm:text-xl" data-id="element-286" data-mp="1hd6je1k0fxvi">
          <p className="font-display text-2xl font-bold leading-snug text-ink sm:text-3xl" data-id="element-287" data-mp="1ced4q5szm0tr">
            You have studied anatomy. You understand biomechanics. You have learned assessment techniques.
          </p>
          <p data-id="element-288" data-mp="1mapxn1gpkang">
            But when a patient presents with persistent pain, confusing symptoms, or findings that do not fit the usual
            pattern, <strong className="text-ink" data-id="element-289" data-mp="tmu2i16seqss">do you always know what to investigate next?</strong>
          </p>
          <p data-id="element-290" data-mp="1bd3ffwdwkj78">
            I created the Musculoskeletal Clinical Pathway™ to help you organize the information you collect, recognize
            findings that deserve closer attention, and follow a more structured approach to your initial assessment.
          </p>
          <p className="rounded-2xl border-l-4 border-brand bg-white p-5 text-ink" data-id="element-291" data-mp="1l3oibw0m09vy">
            Instead of jumping between notes, searching for scattered information, or relying entirely on memory, you will
            have a <strong data-id="element-292" data-mp="sgka7i67zffy">practical reference system to guide your clinical reasoning.</strong>
          </p>
        </div>

        <SectionCta label="I’m Ready for a Clearer Process" data-id="element-293" data-mp="11ew0tk736d8e" />
      </div>
    </section>;
}